<template>
  <div class="dashboard-section">
    <b-container fluid>
      <!-- style="margin-bottom:20px; margin-top:20px" -->

      <b-row class="mt-2 mb-2">
        <b-col>
          <b-button variant="success" @click="showAllMap">
            All Maps
          </b-button>
          <b-button variant="primary" style="margin-left:10px" @click="clearMap">
            Clear
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="2">
          <b-table
            head-variant="dark"
            small
            striped
            hover
            :items="items"
            :fields="fieldsSet"
            :busy="isFetching"
          >
            <div slot="table-busy" class="text-center text-danger">
              <b-spinner variant="danger" small />
              <strong>Loading...</strong>
            </div>
            <template slot="top-row" slot-scope="{ fields }">
              <td v-for="field in fields" :key="field.key">
                <b-form-input
                  v-if="field.key !== 'index'"
                  v-model="filtering[field.key]"
                  size="sm"
                  :placeholder="field.label"
                  trim
                  @input="debounceSearch('filter')"
                />
              </td>
            </template>
            <template slot="HEAD_index">
              #
            </template>
            <template slot="index" slot-scope="data">
              {{ data.index + 1 }}
            </template>
            <template slot="outletCode" slot-scope="data">
              <a href @click.prevent="showMap(data.item)">
                {{ data.value }}
              </a>
            </template>
          </b-table>
        </b-col>
        <b-col cols="10">
          <div class="travel-map">
            <div ref="googleMap" class="google-map" />
            <template v-if="Boolean(google) && Boolean(map)">
              <slot :google="google" :map="map" />
            </template>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3">
          <b-pagination
            v-model="paging.page"
            align="right"
            for="table"
            :total-rows="paging.total"
            :per-page="paging.size"
            :limit="limitPaging(paging.page, paging.total)"
            @input="reload"
          >
            <div slot="ellipsis-text">
              ...
            </div>
            <span
              slot="first-text"
              :class="(paging.page < 6 || Math.ceil(paging.total / paging.size) < 8 ) ? 'hidden' : ''"
            >
              1
            </span>
            <span
              slot="last-text"
              :class=" (paging.page > (Math.ceil(paging.total / paging.size) - 5) || Math.ceil(paging.total / paging.size) < 8 ) ? 'hidden' : ''"
            >
              {{ Math.ceil(paging.total / paging.size) }}
            </span>
          </b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style lang="scss" scoped>
@import 'StoreGeofence';
</style>
<script>
import GoogleMapsApiLoader from 'google-maps-api-loader';
import { mapSettings, POLYGON_CONFIG } from './google/mapSettings';
import api from '@/api';
import { debounce } from 'lodash-es';

export default {
  data() {
    return {
      fieldsSet: ['index', 'outletCode'],
      items: [],
      google: null,
      map: null,
      polygons: [],
      filtering: {
        outletCode: null
      },
      paging: {
        page: 1,
        size: this.$store.state.defaultPerPage,
        total: 0
      },
      debounceSearch: null,
      isFetching: false
    };
  },

  created() {
    this.debounceSearch = debounce(this.reload, 1000);
    this.reload();
  },

  async mounted() {
    // load map and filled store data
    this.google = await GoogleMapsApiLoader({
      apiKey: process.env.VUE_APP_GOOGLEMAPS_KEY
    });

    this.mapConfig = {
      ...mapSettings,
      center: { lat: -6.2391912, lng: 106.9070686 }
    };

    this.map = new this.google.maps.Map(this.$refs.googleMap, this.mapConfig);

    this.map.addListener('click', async e => {
      var response = await api.NearestStore(e.latLng.lat(), e.latLng.lng());

      if (response.data.data === null) {
        this.removeAllPolygon();
      } else {
        this.showMap(response.data.data);
      }
    });
  },
  methods: {
    limitPaging(page, total) {
      if (page < 6) {
        return 7;
      }
      if (page > Math.ceil(total / this.paging.size) - 5) {
        return 7;
      }
      return 5;
    },

    removeAllPolygon() {
      while (this.polygons.length > 0) {
        this.polygons.shift().setMap(null);
      }
    },

    showMap(item) {
      this.removeAllPolygon();
      this.showPolygon(item.outletCode, item.positions);
    },

    showAllMap() {
      this.removeAllPolygon();
      for (const key in this.items) {
        this.showPolygon(this.items[key].outletCode, this.items[key].positions);
      }
    },

    clearMap() {
      this.removeAllPolygon();
    },

    showPolygon(outletCode, positions) {
      var paths = JSON.parse(positions);
      var polygon = new this.google.maps.Polygon({
        paths: paths,
        ...POLYGON_CONFIG
      });
      polygon.setMap(this.map);
      this.polygons.push(polygon);

      polygon.addListener('click', event => {
        var infoWindow = new this.google.maps.InfoWindow();
        infoWindow.setContent(outletCode);
        infoWindow.setPosition(event.latLng);
        infoWindow.open(this.map);
      });
    },

    async reload(arg) {
      if (arg === 'filter') {
        this.paging.page = 1;
      }
      try {
        this.isFetching = true;
        let response = await api.GetStoreGeofence(
          this.filtering.outletCode,
          this.paging.page,
          this.paging.size
        );
        this.isFetching = false;
        this.items = response.data.data;
        this.paging.total = response.headers['data-length'];

        while (this.items.total < this.paging.size) {
          this.items.push({});
        }
      } catch (e) {
        this.isFetching = false;
      }
    }
  }
};
</script>
